import { toast } from "react-toastify";
import { Company } from "../models/company.model";
import { Organization } from "../models/organization.model";
import { User } from "../models/user.model";
import { responseHero } from "../utils/axiosInterceptor";
import { DaisyContractDetail } from "../types/daisyContractDetail";
import { BankAccount } from "../models/bank.account.model";
import { CryptoAccount } from "../models/crypto.account.model";

export const makeContract = async (
    user: User | undefined,
    org: Organization | undefined,
    company: Company | undefined,
    currency: string, 
    amount: number,
    lendAmount: number,
    template_ref_id: string | null | undefined,
    accountData?: BankAccount | CryptoAccount | null | undefined,
    envelope_ref_id?: string | null | undefined,
    daisyContractDetail?: DaisyContractDetail
): Promise<string | null> => {

    if (user && org) {
        toast.error('Hiba a szerződés küldése közben!');
        return null;
    }

    if (!template_ref_id) {
        console.log("api komponensbe kapott ref: " + template_ref_id)
        toast.error('Hibás template referencia azonosító');
        return null;
    }

    try {
        const response = await responseHero.post(`${process.env.REACT_APP_API_URL}/makeEnvelope`, {
            user,
            org,
            company,
            template_ref_id,
            currency,
            amount,
            lendAmount,
            accountData,
            envelope_ref_id,
            daisyContractDetail
        });

        toast.success('Sikeres a szerződésküldés!');
        return response.data.url;

    } catch (error: any) {
        console.error(error?.response?.data || error);
        toast.error('Hiba történt a szerződésküldés során.');
        return null;
    }
}
